// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  apiServer: 'https://members.onemedical.com',
  enableProdMode: true,
  devRoutes: false,
  myoneServer: 'https://members.onemedical.com',
  marketingSite: 'https://www.onemedical.com',
  topLevelDomain: '.onemedical.com',
  oneMedicalPhone: '415-291-0480',
  mixpanelToken: '10bbe22fd98e982099a9467e581473a5',
  mixpanelDebug: false,
  gaAccount: 'UA-3271386-1',
  facebookAccount: '353058781520680',
  linkedinPartnerId: '40735',
  hotjarId: '293933',
  appStoreLink: 'https://itunes.apple.com/us/app/one-medical-mobile/id393507802?mt=8',
  googlePlayLink: 'https://play.google.com/store/apps/details?id=com.onemedical.android&hl=en',
  googlePlacesKey: 'AIzaSyCsUFbk8SFCg7QI37b4YjaGFfRFd7IH3jQ',
  pusherKey: '68339ece8c51988bd9c4',
  recaptchaSiteKey: '6LfIC18UAAAAAL0wIg_YeHCL6wOy2Tvtpl5CWDZF',
  rollbarAccessToken: '8f6a0a77b34c41e2a75a79e6956d14fd',
  rollbarEnvironment: 'production',
  stripePublishableKey: 'pk_live_blfjciDlbyNuIfvVOaPvqJaF',
  typeaheadDataLoggingUrl: 'https://any-ac-ml-production.app.1life.com/data-logging/member',
  typeaheadSearchUrl: 'https://any-ac-ml-production.app.1life.com/autocomplete/member',
  typeaheadTestingMode: false,
  opsUrl: 'https://www.patientops.com',
};
